import Vue from 'vue'

const verificationUtil = {
  // 正浮点数
  isPositiveFloatReg: /^\d+(\.\d+)?$/,
  // 正整数
  isPositiveReg: /^\d+?$/,
  // 非零正整数
  isNonzeroPositiveReg: /^[1-9]{1}\d*$/,
  // 非零正浮点数
  isNonzeroPositiveFloatReg: /^([1-9]{1}|[1-9]+(\.\d+)?|\d+(\.\d+)+)$/,
  // 两位小数的钱
  isMoneyReg: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
  // 小于1W
  isNumberLess1W: /^(0|10000|[1-9]{1}[0-9]{0,4}(\.\d+)?|[0]{1}(\.\d+){1})$/,
  // 手机号
  isPhoneReg: /^1[3456789]\d{9}$/,
  // 电话号码
  isTelReg: /^((0\d{2,3}(-|\s)\d{7,8})|(1[3456789]\d{9}))$/,
  // 车牌号
  isPlateNumber: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]+[A-Z]+[A-Z0-9]{5,6}$/,
  // 车座位数校验
  isPositiveVehicleLoadNum: /([1-9]\d+)|[4-9]/,
  // 经度
  isLng: /^[-]?((0|[1-9]{1,2}|[1]{1}[0-7]{1}[0-9]{1})(\.\d+)?|180){1}$/,
  // 纬度
  isLat: /^[-]?((0|[1-8]{1,2})(\.\d+)?|90){1}$/,
  // 检测是不是中文或英文
  isCEReg: /^[\u4e00-\u9fa5_a-zA-Z]+$/,
  // 非中文
  isNotCh: /^[^\u4e00-\u9fa5]+$/ig,
  isCh: /^[\u4e00-\u9fa5]+$/ig,
  // 特殊字符
  noSpecialReg: /^[^#$%^&*'"?<>//!！@]+$/ig,
  // 邮箱
  isEmail: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
  // 字母和数字
  isEngNum: /^[0-9a-zA-Z]+$/,
  // hex 表示颜色
  isHexColor: /^#[0-9a-zA-Z]{6}/,
  // 统一社会信用代码
  isSocialCreditCode: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/
}

Vue.prototype.$verification = verificationUtil

export default verificationUtil